import { useState } from 'react'

import { ShareUnit, ShareUnitToggle } from '@digital-twins/deck-ui/plots/_shared'
import { CategoricalSharePayload, CategoricalSharePlotView } from '@digital-twins/deck-ui/plots/categorical-share'

import { FigureControls, FigurePanelSections, FigureViewProps, useShareUnitLabels } from './figureViewShared'

/**
 * `stacked-100-bars` and `grouped-bars` on the survey tab (plots plan L, Wave
 * 7 S1): the kinds' own plot view (`CategoricalSharePlotView`), the one the
 * analyst tab and quick study draw, at its report size. Shape only: shares are
 * Python's and never re-normalised; rows and categories are drawn in Python's
 * order with Python's crown and colour slots. "Other" opens in place
 * (decision 23) when the payload stamps what it folded and the host passes the
 * link's words. A cut draws one titled plot per group.
 */
export function CategoricalFigure(props: FigureViewProps) {
  const { question, panels, isCut, locale, otherToggleLabels, initialShareUnit = 'percent', fixedShareDecimals } = props

  const [shareUnit, setShareUnit] = useState<ShareUnit>(initialShareUnit)
  const shareUnitLabels = useShareUnitLabels()

  const testIdPrefix = question.kind === 'stacked-100-bars' ? 'figure-stacked-100-bars' : 'figure-grouped-bars'

  return (
    <FigureControls testId={testIdPrefix} placement={props.controlsPlacement} controls={<ShareUnitToggle value={shareUnit} onChange={setShareUnit} labels={shareUnitLabels} testIdPrefix={`${testIdPrefix}-share-unit-`} />}>
      <FigurePanelSections
        panels={panels}
        isCut={isCut}
        testIdPrefix={testIdPrefix}
        renderPanel={(panel, index) => (
          <CategoricalSharePlotView
            plot={panel.plot as unknown as CategoricalSharePayload}
            size="report"
            locale={locale}
            renderMode="interactive"
            otherToggleLabels={otherToggleLabels}
            shareUnit={shareUnit}
            fixedShareDecimals={fixedShareDecimals}
            fastHover
            testIdPrefix={isCut ? `${testIdPrefix}-${index}-plot` : `${testIdPrefix}-plot`}
          />
        )}
      />
    </FigureControls>
  )
}
